import React from "react";
import "./StatusStats.css";

const StatusStats = ({ acceptedCount, pendingCount, rejectedCount, pendingTitle }) => (
  <div className="status-stats" role="group" aria-label="Status counts">
    <div className="status-stats-card status-stats-card--accepted">
      <div className="status-stats-icon" aria-hidden>
        <i className="bi bi-check-circle-fill" />
      </div>
      <div className="status-stats-body">
        <span className="status-stats-label">Accepted</span>
        <span className="status-stats-value">{acceptedCount}</span>
      </div>
    </div>
    <div className="status-stats-card status-stats-card--pending" title={pendingTitle}>
      <div className="status-stats-icon" aria-hidden>
        <i className="bi bi-hourglass-split" />
      </div>
      <div className="status-stats-body">
        <span className="status-stats-label">Pending</span>
        <span className="status-stats-value">{pendingCount}</span>
      </div>
    </div>
    <div className="status-stats-card status-stats-card--rejected">
      <div className="status-stats-icon" aria-hidden>
        <i className="bi bi-x-circle-fill" />
      </div>
      <div className="status-stats-body">
        <span className="status-stats-label">Rejected</span>
        <span className="status-stats-value">{rejectedCount}</span>
      </div>
    </div>
  </div>
);

export default StatusStats;
